// Your web app's Firebase configuration
export const firebaseConfig = {
    apiKey: "AIzaSyDdBGRuD62r39dkrEFXyyB8hCfRl2Xu6UU",
    authDomain: "dh2642-tidab.firebaseapp.com",
    databaseURL: "https://dh2642-tidab-default-rtdb.europe-west1.firebasedatabase.app/",
    projectId: "dh2642-tidab",
    storageBucket: "dh2642-tidab.appspot.com",
    messagingSenderId: "1039545828333",
    appId: "1:1039545828333:web:87531dec8600f174e2dde4",
    measurementId: "G-XNVQW945JF"
};